"use client";
import {
  ErrorPage,
  ErrorPageButton,
  ErrorPageContent,
  ErrorPageIcon,
  ErrorPageSubtitle,
  ErrorPageTitle,
} from "@xenithlabs/xenith-ui";
import Link from "next/link";

export function NotFoundPage({
  buttonType = "refresh",
}: {
  buttonType?: "refresh" | "home" | "none";
}) {
  return (
    <div className="mt-[200px]">
      <ErrorPage>
        <ErrorPageIcon />
        <ErrorPageContent>
          <ErrorPageTitle>404 Error.</ErrorPageTitle>
          <ErrorPageSubtitle>
            Oops! This page could not be found.
          </ErrorPageSubtitle>
          {buttonType === "home" && (
            <Link href="/">
              <ErrorPageButton className="mt-2">Back to Home</ErrorPageButton>
            </Link>
          )}
          {buttonType === "refresh" && (
            <ErrorPageButton
              className="mt-2"
              onClick={() => window.location.reload()}
            >
              Refresh page
            </ErrorPageButton>
          )}
        </ErrorPageContent>
      </ErrorPage>
    </div>
  );
}
